var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'cursor-pointer': _vm.fieldIsSortable },on:{"click":function($event){$event.stopPropagation();return _vm.$emit('sort', _vm.columnName)}}},[_c('TextLabel',{attrs:{"text":_vm.$t(
        ("_web_participants-list_column-" + _vm.columnName),
        _vm.$filters.startCase(_vm.columnName)
      ),"variant":"caption"}}),(_vm.fieldIsSortable && _vm.sortIcon)?_c('Icon',{attrs:{"name":_vm.sortIcon,"width":"16","original":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }